import format from "date-fns/format";
export const transformToMonthName = (dateString: string): string => {
  const date = new Date(dateString);
  return format(date, "MMMM yyyy");
};
